const PEM_HEADER = '-----BEGIN PUBLIC KEY-----';
const PEM_FOOTER = '-----END PUBLIC KEY-----';
export async function generateSymmetricKey() {
    return window.crypto.subtle.generateKey({
        name: 'AES-GCM',
        length: 256
    }, true, ['encrypt', 'decrypt']);
}
export async function importSymmetricKey(rawKey) {
    return window.crypto.subtle.importKey('raw', rawKey, 'AES-GCM', false, ['decrypt']);
}
export async function exportSymmetricKey(key) {
    return window.crypto.subtle.exportKey('raw', key);
}
export function getIV(size) {
    return window.crypto.getRandomValues(new Uint8Array(size));
}
export async function encryptPredictions(data, key, iv) {
    return window.crypto.subtle.encrypt({
        name: 'AES-GCM',
        iv,
        tagLength: 128
    }, key, data);
}
export async function decryptPrediction(data, key, iv) {
    return window.crypto.subtle.decrypt({
        name: 'AES-GCM',
        iv,
        tagLength: 128
    }, key, data);
}
function _str2ab(str) {
    const buf = new ArrayBuffer(str.length);
    const bufView = new Uint8Array(buf);
    for (let i = 0; i < str.length; i++) {
        bufView[i] = str.charCodeAt(i);
    }
    return buf;
}
export async function importRsaPublicKey(pem) {
    // fetch the part of the PEM string between header and footer
    const pemContents = pem.substring(PEM_HEADER.length, pem.length - PEM_FOOTER.length);
    // base64 decode the string to get the binary data
    const binaryDerString = window.atob(pemContents);
    // convert from a binary string to an ArrayBuffer
    const binaryDer = _str2ab(binaryDerString);
    return window.crypto.subtle.importKey('spki', binaryDer, {
        name: 'RSA-OAEP',
        hash: 'SHA-1'
    }, true, ['wrapKey', 'encrypt']);
}
export async function wrapSymmetricKey(symmetricKey, publicKey) {
    const wrapKeyResult = await window.crypto.subtle.wrapKey('raw', symmetricKey, publicKey, publicKey.algorithm.name);
    return new Uint8Array(wrapKeyResult);
}
